<template>
  <div class="cont_head">
    <div class="cont_he">
      <div class="cont_s">
        <h1>建当复核</h1>
        <span>NO：<input type="text" v-model="inputpiao" /></span>
      </div>

      <table width="95%">
        <tr>
          <td rowspan="2" width="8%">典当行</td>
          <td width="12%">名称</td>
          <td width="33%">{{ info_ddh.name }}</td>
          <td width="15%">电话</td>
          <td width="32%">{{ info_ddh.tel }}</td>
        </tr>
        <tr>
          <td>地址</td>
          <td>{{ info_ddh.address }}</td>
          <td>经营许可证编码</td>
          <td>{{ info_ddh.licence }}</td>
        </tr>
        <tr>
          <td rowspan="3">当户</td>
          <td>名称</td>
          <td><input type="text" v-model="inputname" /></td>
          <td>电话</td>
          <td><input type="text" v-model="inputtel" /></td>
        </tr>
        <tr>
          <td>地址</td>
          <td><input type="text" v-model="inputadd" /></td>
          <td>联系人</td>
          <td><input type="text" v-model="inputname" /></td>
        </tr>
        <tr>
          <td>证件名称</td>
          <td><input type="text" v-model="inputtype" /></td>
          <td>证件号码</td>
          <td><input type="text" v-model="inputcard" /></td>
        </tr>
      </table>
      <table width="95%">
        <tr height="100px">
          <td width="8%">序号</td>
          <td width="17%">当物名称</td>
          <td width="12%">规格和状况</td>
          <td width="4%">数量</td>
          <td width="4%">重量/g</td>
          <td width="8%">上交所金价</td>
          <td width="8%">典当单价</td>
          <td width="10%">折当率/%</td>
          <td width="10%">典当金额/元</td>
          <td width="10%">典当综合费/元</td>
          <td width="12%">典当利息/元</td>
        </tr>

        <tr>
          <td width="8%">1</td>
          <td width="17%"><input type="text" v-model="inputitem" /></td>
          <td width="12%"><input type="text" v-model="inputspec" /></td>
          <td width="4%"><input type="text" v-model="inputnumbera" /></td>
          <td width="4%"><input type="text" v-model="inputweia" /></td>
          <td width="8%">{{ datas.realpricea }}</td>
          <td width="8%">{{ datas.unitpricea }}</td>
          <td width="10%"><input type="text" v-model="rate" /></td>
          <td width="10%"><input type="text" v-model="pric" /></td>
          <td width="10%" rowspan="3"><input type="text" v-model="inputzhpri" /></td>
          <td width="12%" rowspan="3"><input type="text" v-model="lx" /></td>
        </tr>

        <tr>
          <td width="8%">{{ inputitema == "" ? "" : 2 }}</td>
          <td width="17%"><input type="text" v-model="inputitema" /></td>
          <td width="12%"><input type="text" v-model="inputspeca" /></td>
          <td width="4%"><input type="text" v-model="inputnumberaa" /></td>
          <td width="4%"><input type="text" v-model="inputweiaa" /></td>
          <td width="8%">{{ datas.realpriceaa }}</td>
          <td width="8%">
            {{ datas.unitpriceaa == "计算中..." ? "" : datas.unitpriceaa }}
          </td>
          <td width="10%"><input type="text" v-model="ratea" /></td>
          <td width="10%"><input type="text" v-model="prica" /></td>
          <!-- <td width="12%"></td> -->
        </tr>

        <tr>
          <td width="8%">{{ inputitemaa == "" ? "" : 3 }}</td>
          <td width="17%"><input type="text" v-model="inputitemaa" /></td>
          <td width="12%"><input type="text" v-model="inputspecaa" /></td>
          <td width="4%"><input type="text" v-model="inputnumberaaa" /></td>
          <td width="4%"><input type="text" v-model="inputweiaaa" /></td>
          <td width="8%">{{ datas.realpriceaaa }}</td>
          <td width="8%">
            {{ datas.unitpriceaaa == "计算中..." ? "" : datas.unitpriceaaa }}
          </td>
          <td width="10%"><input type="text" v-model="rateaa" /></td>
          <td width="10%"><input type="text" v-model="pricaa" /></td>
          <!-- <td width="12%"></td> -->
        </tr>
      </table>

      <table width="95%">
        <tr height="60px">
          <td width="14%">典当期限：</td>
          <td width="5%">由</td>
          <td width="20%"><input type="text" v-model="inputstart" /></td>
          <td width="5%">至</td>
          <td width="20%"><input type="text" v-model="inputend" /></td>
          <td width="9%">典当周期：{{ inputcycle }}天</td>
        </tr>
      </table>

      <table width="95%">
        <tr height="130px">
          <td style="text-align: left">
            评估师意见/备注：<input type="text" v-model="opinion" />
            <br />
            <br />
            <br />
            <br />
            备注：补充约定：逾期续当/赎当将按月费率4.5%收取续当期间典当综合费和利息，当期不足5日的，按5日收取有关费用，逾期赎当按天数在费率基础上加收50%罚息；并遵守背面《典当须知》。
            <br />
            <br />

            /**小提示：红色字体的信息是可以修改的哦，如果建当信息有误，可直接修改红色字体的内，再点确定复核哦**/
          </td>
        </tr>
      </table>
      <div class="tas">
        <span>复核：{{ review }}</span>
        <span>经办人：{{ this.datas.agent }}</span>
        <span>保管：</span>
        <span>制单时间：{{ inputdate }}</span>
      </div>
      <el-button type="primary" @click="submit">确定复核</el-button>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
import util from "@/components/util";
export default {
  name: "revs",

  data() {
    return {
      id: "", //拿到订单的id
      ACCESS_TOKEN: "", //get请求的ACCESS_TOKEN密钥
      items: "",

      //输入框的默认值
      inputdate: "", //建档日期
      inputname: "", //当户名字
      inputadd: "", //证件地址
      inputtype: "", //证件类型
      inputcard: "", //证件号码
      inputpiao: "", //票号
      inputtel: "", //电话
      inputitem: "", //物品名字
      inputitname: "", //物品类型
      inputspec: "", //规格
      inputnumber: "", //总数量
      inputweight: "", //总物品重量
      inputprice: "", //总典当价格
      inputstart: "", //典当开始日
      inputend: "", //典当结束日
      inputcycle: "", //典当周期
      inputmode: "", //支付方式
      inputzhpri: "", //总典当综合费
      lx: 0,
      rate: "", //折当率
      opinion: "", //评估意见
      // agent: "", //经办人
      review: "", //复核
      finance: "", //财务
      token: "", //token

      daydate: "", //复核的日期（今天的日期）

      datas: "", //请求回来全部数据
      gzh_token: "", //公众号的token

      inputitema: "", //第二栏物品名字
      inputitemaa: "", //第三栏物品名字
      inputspeca: "", //第二栏物品规格
      inputspecaa: "", //第三栏物品规格
      inputnumbera: "", //第一栏数量
      inputnumberaa: "", // 第二栏数量
      inputnumberaaa: "", //第三栏数量
      inputweia: "", //第一栏重量
      inputweiaa: "", //第二栏重量
      inputweiaaa: "", //第三栏重量
      ratea: "", //第二栏折当率
      rateaa: "", //第三栏折当率
      pric: "", //第一栏典当金额
      prica: "", //第二栏典当金额
      pricaa: "", //第三栏典当金额

      info_ddh: {}, //典当行的数据
    };
  },

  methods: {
    //请求典当行信息
    getDinfo() {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: 'db.collection("smsTemplate").doc("' + this.id + '").get()',
        })
        .then((r) => {
          r.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
        });
    },
    //请求被点击的数据执行方法
    getData() {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: 'db.collection("add_data").doc("' + this.id + '").get()',
        })
        .then((res) => {
          res.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          this.datas = res.data.data[0];
          (this.inputdate = res.data.data[0].deta),
            (this.inputname = res.data.data[0].name), //当户名字
            (this.inputadd = res.data.data[0].address), //证件地址
            (this.inputtype = res.data.data[0].type), //证件类型
            (this.inputcard = res.data.data[0].cardnumber), //证件号码
            (this.inputpiao = res.data.data[0].ticketnumber), //票号
            (this.inputtel = res.data.data[0].telnumber), //电话
            (this.inputitem = res.data.data[0].objname), //物品名字
            (this.inputitname = res.data.data[0].itemname), //物品类型
            (this.inputspec = res.data.data[0].speci), //规格
            (this.inputnumber = res.data.data[0].number), //数量
            (this.inputweight = res.data.data[0].weight), //物品重量
            (this.inputprice = res.data.data[0].price), //典当价格
            (this.inputstart = res.data.data[0].startdate), //典当开始日
            (this.inputend = res.data.data[0].enddate), //典当结束日
            (this.inputcycle = res.data.data[0].days), //典当周期
            (this.inputmode = res.data.data[0].mode), //支付方式
            (this.inputzhpri = res.data.data[0].cost), //典当综合费
            (this.lx = res.data.data[0].lx), //典当利息
            // (this.agent = res.data.data[0].agent), //经办人
            (this.rate = res.data.data[0].rate), //折当率
            (this.opinion = res.data.data[0].opinion), //评估意见
            // (this.review = res.data.data[0].review); //复核
            // (this.finance = res.data.data[0].finance); //财务

            (this.inputitema = res.data.data[0].objnamea), //第二栏物品名字
            (this.inputitemaa = res.data.data[0].objnameaa), //第三栏物品名字
            (this.inputspeca = res.data.data[0].specia), //第二栏规格
            (this.inputspecaa = res.data.data[0].speciaa), //第三栏规格
            (this.inputnumbera = res.data.data[0].num), //第一栏数量
            (this.inputnumberaa = res.data.data[0].numa), // 第二栏数量
            (this.inputnumberaaa = res.data.data[0].numaa); //第三栏数量
          this.inputweia = res.data.data[0].weig; //第一栏重量
          this.inputweiaa = res.data.data[0].weiga; //第二栏重量
          this.inputweiaaa = res.data.data[0].weigaa; //第三栏重量
          this.ratea = res.data.data[0].ratea; //第二栏折当率
          this.rateaa = res.data.data[0].rateaa; //第三栏折当率
          this.pric = res.data.data[0].pric; //第一栏典当金额
          this.prica = res.data.data[0].prica; //第二栏典当金额
          this.pricaa = res.data.data[0].pricaa; //第三栏典当金额
        });
    },
    //添加建当记录
    yover() {
      this.axios
        .post("/api/tcb/databaseadd?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("yxus_record").add({data:{name:"${this.datas.name}",xuday:"${this.daydate}",itemname:"${this.datas.objname}",ticketnumber:"${this.datas.ticketnumber}",telnumber:"${this.datas.telnumber}",xupri:"${this.datas.cost}",enddate:"${this.datas.enddate}",dday:"${this.datas.days}",xuname:"${this.review}",overdate:"${this.datas.startdate}",ytdy:"0",pena:"0",rece:"${this.datas.price}",stas:"建当",pri:"${this.datas.price}",lx:"${this.lx}",yspri:"${this.datas.yspri}",couqons:"不适用",couqonmoney:"0",cardnumber:"${this.datas.cardnumber}",agent:"${this.datas.agent}",review:"${this.datas.review}",finance:"",weight:"${this.datas.weight}"}})`,
        })
        .then((rcc) => {
          if (rcc.data.errcode == 0) {
            setTimeout(() => {
              this.$router.push("/review");
            }, 2000);
          }
        });
    },

    //提交复核操作
    submit() {
      //先判断该业务是否有被复核过
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("add_data").doc("${this.id}").get()`,
        })
        .then((res) => {
          res.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          if (res.data.data[0].review == "") {
            this.upData();
          } else {
            this.$message.error("该业务已复核，请关闭当前页面");
          }
        });

      // if(){

      // }else{

      // }
    },
    //提交复核修改数据
    upData() {
      this.$confirm("是否要复核订单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          //修改后的数据
          this.axios
            .post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
              env: `${this.userData.env}`,
              query:
                'db.collection("add_data").doc("' +
                this.id +
                '").update({data:{ticketnumber:"' +
                this.inputpiao +
                '",deta:"' +
                this.inputdate +
                '",name:"' +
                this.inputname +
                '",telnumber:"' +
                this.inputtel +
                '",address:"' +
                this.inputadd +
                '",itemname:"' +
                this.inputitname +
                '",type:"' +
                this.inputtype +
                '",cardnumber:"' +
                this.inputcard +
                '",objname:"' +
                this.inputitem +
                '",speci:"' +
                this.inputspec +
                '",number:"' +
                this.inputnumber +
                '",weight:"' +
                this.inputweight +
                '",price:"' +
                this.inputprice +
                '",startdate:"' +
                this.inputstart +
                '",enddate:"' +
                this.inputend +
                '",mode:"' +
                this.inputmode +
                '",days:"' +
                this.inputcycle +
                '",cost:"' +
                this.inputzhpri +
                '",review:"' +
                this.review +
                '",finance:"' +
                this.finance +
                '",agent:"' +
                this.datas.agent +
                '",zpri:"' +
                this.inputzhpri +
                '",whether:true,reviewdate:"' +
                this.daydate +
                '",lx:"' +
                this.lx +
                '",objnamea:"' +
                this.inputitema +
                '",specia:"' +
                this.inputspeca +
                '",numa:"' +
                this.inputnumberaa +
                '",weiga:"' +
                this.inputweiaa +
                '",ratea:"' +
                this.ratea +
                '",prica:"' +
                this.prica +
                '",objnameaa:"' +
                this.inputitemaa +
                '",speciaa:"' +
                this.inputspecaa +
                '",numaa:"' +
                this.inputnumberaaa +
                '",weigaa:"' +
                this.inputweiaaa +
                '",rateaa:"' +
                this.rateaa +
                '",pricaa:"' +
                this.pricaa +
                '"}})',
            })
            .then((ces) => {
              if (ces.data.errcode == 0) {
                this.yover();
                this.$notify({
                  title: "复核成功",
                  message: "恭喜你，该订单已复核成功",
                  type: "success",
                });

                this.ceDs(this.inputcard, this.datas);

                this.sendOrders();
                // util.sendOrder(
                //   dayjs().format("YYYY-MM-DD HH:mm:ss"),
                //   "同意建当",
                //   this.inputname,
                //   "（建当）",
                //   this.inputpiao,
                //   `复核人：${this.review}已同意复核,请当台及时处理`,
                //   this.ACCESS_TOKEN
                // );
              } else {
                this.$notify.error({
                  title: "错误",
                  message: "token过期,请刷新页面再试",
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消复核",
          });
        });
    },

    //发送新工单提醒
    sendOrders() {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("weReviewTemplate").where({}).get()`,
        })
        .then((res) => {
          res.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });

          if (res.data.errcode == 0) {
            this.axios
              .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
                env: `${this.userData.env}`,
                query: `db.collection("weTemplate").where({}).get()`,
              })
              .then((re) => {
                re.data.data.forEach((element, index, array) => {
                  array[index] = JSON.parse(element);
                });

                this.axios
                  .get("/getToken/GetTokenGZH", {
                    params: {
                      id: re.data.data[0].gzhTokenID,
                      appid: re.data.data[0].mpappid,
                      secret: re.data.data[0].secret,
                    },
                  })
                  .then((r) => {
                    this.sendReview(res.data.data, r.data[0].AccessToken);
                  });
              });
          }
        });
    },

    sendReview(event, token) {
      for (let i = 0; i < event.length; i++) {
        util.sendOrder(
          dayjs().format("YYYY-MM-DD HH:mm:ss"),
          "同意建当",
          this.inputname,
          "（建当）",
          this.inputpiao,
          `复核人：${this.review}已同意复核,请当台及时处理`,
          token,
          event[i]
        );
      }
    },

    //发微信推送
    ceDs(idcard, datas) {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("user2020zl").where({idcard:"${idcard}"}).get()`,
        })
        .then((ruser) => {
          ruser.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });

          this.axios
            .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
              env: `${this.userData.env}`,
              query: `db.collection("openids").where({unionid:"${ruser.data.data[0].unionid}"}).get()`,
            })
            .then((ra) => {
              ra.data.data.forEach((element, index, array) => {
                array[index] = JSON.parse(element);
              });

              //拿到返回的公众号openid

              this.getSendInfo(ra.data.data[0].openid, datas);
            });
        });
    },

    //请求该用户的微信推送信息
    getSendInfo(openid, datas) {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("weTemplate").where({}).get()`,
        })
        .then((res) => {
          res.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });

          // 微信公众号token
          this.axios
            .get("/getToken/GetTokenGZH", {
              params: {
                id: res.data.data[0].gzhTokenID,
                appid: res.data.data[0].mpappid,
                secret: res.data.data[0].secret,
              },
            })
            .then((re) => {
              //hu
              this.getUid(openid, datas, res.data.data[0], re.data[0].AccessToken);
            });
        });
    },

    //发微信推送推送给客户
    getUid(openid, datas, info, token) {
      this.axios.post("/api/cgi-bin/message/template/send?access_token=" + token, {
        touser: openid,
        // mp_template_msg: {
        appid: info.mpappid, //长安 wx9019ccce538953c5
        template_id: info.createTemplate, //长安 JLKZnQAtGhZEgsv6Ng8vUFcVV2e0qbEHf9-g2oJMGZA
        url: "http://weixin.qq.com",
        miniprogram: {
          appid: info.xcxappid,
          pagepath: "pages/offline/offlines/index",
        },
        data: {
          first: {
            value: `尊敬的${datas.name}先生/女士，感谢您在长安典当行办理典当业务`,
            color: "#173177",
          },
          keyword1: {
            value: datas.ticketnumber,
            color: "#173177",
          },
          keyword2: {
            value: datas.objname,
            color: "#173177",
          },
          keyword3: {
            value: datas.price + "元",
            color: "#173177",
          },
          keyword4: {
            value: datas.startdate,
            color: "#173177",
          },
          keyword5: {
            value: datas.enddate,
            color: "#173177",
          },
          remark: {
            value:
              "点击查看典当信息，支付典当综合费，自主操作续当/赎当，无需到店办，典当会员可享低至5.5折费率",
            color: "#173177",
          },
        },
        // },
      });
    },

    //请求典当行数据
    getInfoddh() {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("info_ddh").where({}).get()`,
        })
        .then((res) => {
          res.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          this.info_ddh = res.data.data[0];
        });
    },

    //微信通知内部工作人员
    // senDnb(){}
  },
  // 生命周期函数，监听页面创建
  created() {
    //拿到被点击的订单id
    this.id = this.$route.query.id;
    //获取ACCESS_TOKEN
    // this.ACCESS_TOKEN = localStorage.getItem("ACCESS_TOKEN");
    //获取到this.ACCESS_TOKEN
    this.getTokens();

    //获取当前登录的用户数据
    this.getUserToken();

    //今天的日期
    this.daydate = dayjs().format("YYYY-MM-DD");
  },

  //修改测试一会到git上去看看，文件修改了没有

  mounted() {
    setTimeout(() => {
      //调用获取复核人姓名
      this.review = this.userData.username;

      this.getData();
      this.getInfoddh();
      // this.getSendInfo();
    }, 800);
  },
};
</script>

<style scoped>
.cont_he {
  width: 80%;
  background-color: #ffffff;
  margin: 20px auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.cont_he h2 {
  margin: 0 20px;
  padding: 20px 20px;
}
.cont_conts {
  width: 95%;
  margin: 0 auto;
}
.cont_o {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  background-color: #e9e9e965;
}
.cont_oleft {
  display: flex;
  flex-direction: row;
  margin: 20px 0;
  justify-content: center;
  align-items: center;
}
.cont_oleft h3 {
  margin-left: 60px;
}
.cont_jdf {
  width: 210px;
}
.cont_t {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: #e9e9e965;
  padding: 20px 0;
  margin: 20px 0;
}
.cont_t h3 {
  margin-left: 40px;
}
.cont_th {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: #e9e9e965;
  padding: 20px 0;
  margin: 20px 0;
}
.cont_th h3 {
  margin-left: 30px;
}
.cont_f {
  margin: 50px 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.cont_fi {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

/* 表格样式 */
.cont_he h1 {
  text-align: center;
  font-size: 25px;
  /* padding: 15px; */
}
.cont_s {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
}
table {
  border-collapse: collapse;
}
td {
  /* width: 100%; */
  height: 35px;
  border: 1px solid black;
  font-size: 12px;
  text-align: center;
}
.tas {
  margin: 20px 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
td input {
  outline: none;
  border: 0;
  color: #c44257;
  width: 90%;
  text-align: center;
}
span input {
  outline: none;
  border: 0;
  color: #c44257;
  width: 50%;
}
</style>
